import { hasAccentedCharacter } from '../_ui/modal/utils';

export const emailErroLabel = (loginUsername: string) => {
  return hasAccentedCharacter(loginUsername) ? 'enter_email_without_special_character' : '';
};
